// This JavaScript file is created by Cision for our calendar module.
// This is the first version of this file so far.

var cision = cision || {};
cision.websolution = cision.websolution || {};
cision.websolution.texts = cision.websolution.texts || {};
cision.websolution.settings = cision.websolution.settings || {};
cision.websolution.formatHelpers = cision.websolution.formatHelpers || {};

cision.websolution.calendar = function ($) {

    var settings = $.extend({}, cision.websolution.settings.general),
        accessKey = (cision.websolution.settings.calendar || {}).accessKey,
        texts = cision.websolution.texts[settings.uiLanguage],
        eventsList = [],
        categories = [],
        firstRunEvent = true,
        firstRunArchive = true;

    function generateUrl(path) {
        var url = settings.useProxyHandler
            ? settings.proxyHandler + '?url=' + settings.serviceEndpoint + path
            : settings.serviceEndpoint + path;
        return url;
    }

    var renderEventList = function (options) {

        if (options) {
            $.extend(settings, options);
        }
        if (settings.accessKey) {
            accessKey = settings.accessKey;
        }
        if (!accessKey) {
            console.log("You must provide your Calendar access key.");
            return;
        }
        var url = generateUrl('Calendar/' + accessKey);
        var d = $.Deferred();
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            data: {
                languageCode: settings.uiLanguage,
                pageIndex: settings.calendarPageIndex,
                pageSize: settings.calendarPageSize || 50,
                startDate: settings.startDate,
                endDate: settings.endDate,
                category: settings.calendarCategory
            }
        })
            .done(function (rawData) {
                var objFirstEvent = null;
                $.each(rawData.Events, function (idx, objEvent) {
                    objEvent.EventTimeFormatted = moment(objEvent.EventTime).locale(settings.uiLanguage).format(settings.dateFormatNews);
                    objEvent.EventTimeFormattedDate = moment(objEvent.EventTime).locale(settings.uiLanguage).format(settings.dateFormat);
                    objEvent.EventTimeFormattedTime = moment(objEvent.EventTime).locale(settings.uiLanguage).format(settings.timeFormat);
                    objEvent.EventWeekDay = moment(objEvent.EventTime).locale(settings.uiLanguage).format("dddd");
                    if (objEvent.LogoUrl > 0) {
                        objEvent.HasImage = true;
                    } else {
                        objEvent.HasImage = false;
                    }
                    objEvent.PublishTimeFormatted = moment(objEvent.PublishTime).locale(settings.uiLanguage).format(settings.dateFormatNews);
                    objEvent.ArchiveTimeFormatted = moment(objEvent.ArchiveTime).locale(settings.uiLanguage).format(settings.dateFormatNews);
                    objEvent.ICalUrl = settings.serviceEndpoint + 'Calendar/' + accessKey + '/EventDetailIcs' +
                        '?eventGuid=' + objEvent.EventGuid +
                        '&languageCode=' + settings.uiLanguage;

                    objEvent.EventDuration = moment.duration(objEvent.EventDuration, "minutes").asHours();
                    objEvent.EndDateWeekDay = moment(objEvent.EventTime).add(objEvent.EventDuration, "hours").locale(settings.uiLanguage).format("dddd");
                    objEvent.EndDateFormattedDate = moment(objEvent.EventTime).add(objEvent.EventDuration, "hours").format(settings.dateFormat);
                    objEvent.EndDateFormattedTime = moment(objEvent.EventTime).add(objEvent.EventDuration, "hours").format(settings.timeFormat);
                    objEvent.IsOneDay = objEvent.EventTimeFormattedDate == objEvent.EndDateFormattedDate;

                    if (firstRunEvent && objEvent.Categories) {
                        $.each(objEvent.Categories, function(idx2, objCategory) {
                            categories.push(objCategory);
                        });
                    }

                    if (settings.separateFirstEvent === true && objFirstEvent === null && settings.calendarCategory == '') {
                        objFirstEvent = objEvent;
                        if (objEvent.HasImage) {
                            objFirstEvent.LogoUrl = objEvent.LogoUrl;
                        }
                    }

                });

                categories = _.uniq(categories);

                if (settings.separateFirstEvent === true && settings.calendarCategory == '') {
                    rawData.Events.shift();
                }


                var compositeModel = $.extend(rawData, texts, settings);

                var tplElement = '#' + (settings.calendarTemplateElement || 'tplCalendarEventListing');
                var renderedHtml = $(tplElement).render(compositeModel, cision.websolution.formatHelpers);

                if (settings.separateFirstEvent && firstRunEvent && objFirstEvent) {
                    $.extend(objFirstEvent, texts, settings);
                    var renderedEventHtml = $("#tplTopEvent").render(objFirstEvent, cision.websolution.formatHelpers);
                    $("#target-event-top").html(renderedEventHtml);
                }
                if (firstRunEvent) {
                    texts.Categories = categories;
                    //$.extend(categories, texts);
                    var renderedCategories = $("#tplCategories").render(texts);
                    $("#target-categories-2").html(renderedCategories);

                }

                var tplTarget = '#' + (settings.calendarOutputTargetElement || 'eventListTarget');
                $(tplTarget).html(renderedHtml);

                firstRunEvent = false;
                d.resolve();
            })
            .fail(function () {
                console.log('Could not retrieve active calendar data');
                d.reject();
            });
        return d.promise();
    };

    var renderSidebarCalendar = function (options) {

        if (options) {
            $.extend(settings, options);
        }
        if (settings.accessKey) {
            accessKey = settings.accessKey;
        }
        if (!accessKey) {
            console.log("You must provide your Calendar access key.");
            return;
        }
        var url = generateUrl('Calendar/' + accessKey);
        var d = $.Deferred();
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            data: {
                languageCode: settings.uiLanguage,
                pageIndex: settings.calendarPageIndex,
                pageSize: settings.calendarPageSize || 50,
                startDate: settings.startDate,
                endDate: settings.endDate,
                category: settings.calendarCategory
            }
        })
            .done(function (rawData) {
                var objFirstEvent = null;
                $.each(rawData.Events, function (idx, objEvent) {
                    objEvent.EventTimeFormatted = moment(objEvent.EventTime).locale(settings.uiLanguage).format(settings.dateFormatNews);
                    objEvent.EventTimeFormattedDate = moment(objEvent.EventTime).locale(settings.uiLanguage).format(settings.dateFormat);
                    objEvent.EventTimeFormattedTime = moment(objEvent.EventTime).locale(settings.uiLanguage).format(settings.timeFormat);
                    objEvent.EventWeekDay = moment(objEvent.EventTime).locale(settings.uiLanguage).format("dddd");
                    if (objEvent.LogoUrl > 0) {
                        objEvent.HasImage = true;
                    } else {
                        objEvent.HasImage = false;
                    }

                    objEvent.PublishTimeFormatted = moment(objEvent.PublishTime).locale(settings.uiLanguage).format(settings.dateFormatNews);
                    objEvent.ArchiveTimeFormatted = moment(objEvent.ArchiveTime).locale(settings.uiLanguage).format(settings.dateFormatNews);
                    objEvent.ICalUrl = settings.serviceEndpoint + 'Calendar/' + accessKey + '/EventDetailIcs' +
                        '?eventGuid=' + objEvent.EventGuid +
                        '&languageCode=' + settings.uiLanguage;

                    objEvent.EventDuration = moment.duration(objEvent.EventDuration, "minutes").asHours();
                    objEvent.EndTimeFormatted = moment(objEvent.EventTime).locale(settings.uiLanguage).add(objEvent.EventDuration, "hours").format(settings.timeFormat);

                    if (firstRunEvent && objEvent.Categories) {
                        $.each(objEvent.Categories, function (idx2, objCategory) {
                            categories.push(objCategory);
                        });
                    }

                    if (settings.separateFirstEvent === true && objFirstEvent === null && settings.calendarCategory == '') {
                        objFirstEvent = objEvent;
                        if (objEvent.HasImage) {
                            objFirstEvent.LogoUrl = objEvent.LogoUrl;
                        }
                    }

                });

                categories = _.uniq(categories);

                if (settings.separateFirstEvent === true && settings.calendarCategory == '') {
                    rawData.Events.shift();
                }

                var compositeModel = $.extend(rawData, texts, settings);

                var tplElement = '#' + (settings.sidebarCalendarTemplateElement || 'tplSidebarCalendar');
                var renderedHtml = $(tplElement).render(compositeModel, cision.websolution.formatHelpers);

                var tplTarget = '#' + (settings.sidebarCalendarOutputTargetElement || 'sidebarCalendarTarget');
                $(tplTarget).html(renderedHtml);

                firstRunEvent = false;
                d.resolve();
            })
            .fail(function () {
                console.log('Could not retrieve active calendar data');
                d.reject();
            });
        return d.promise();
    };

    var renderArchiveList = function (options) {

        if (options) {
            $.extend(settings, options);
        }
        if (settings.accessKey) {
            accessKey = settings.accessKey;
        }
        if (!accessKey) {
            console.log("You must provide your Calendar access key.");
            return;
        }

        var url = generateUrl('Calendar/' + accessKey + '/Archive');
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            data: {
                languageCode: settings.uiLanguage,
                pageIndex: settings.calendarPageIndex,
                pageSize: settings.calendarPageSize || 50,
                startDate: settings.startDate,
                endDate: settings.endDate,
                category: settings.calendarCategory
            }
        })
            .done(function (rawData) {
                $.each(rawData.Events, function (idx, objEvent) {
                    objEvent.EventTimeFormatted = moment(objEvent.EventTime).locale(settings.uiLanguage).format(settings.dateFormatNews);
                    objEvent.EventTimeFormattedDate = moment(objEvent.EventTime).locale(settings.uiLanguage).format(settings.dateFormat);
                    objEvent.EventTimeFormattedTime = moment(objEvent.EventTime).locale(settings.uiLanguage).format(settings.timeFormat);

                    objEvent.PublishTimeFormatted = moment(objEvent.PublishTime).locale(settings.uiLanguage).format(settings.dateFormatNews);
                    objEvent.ArchiveTimeFormatted = moment(objEvent.ArchiveTime).locale(settings.uiLanguage).format(settings.dateFormatNews);

                    if (firstRunArchive && objEvent.Categories) {
                        $.each(objEvent.Categories, function (idx2, objCategory) {
                            categories.push(objCategory);
                        });
                    }

                    eventsList[objEvent.EventGuid] = objEvent;
                });
                //console.log(categories);
                categories = _.uniq(categories);

                var compositeModel = $.extend(rawData, texts, settings);

                var tplElement = '#' + (settings.calendarTemplateElement || 'tplCalendarArchiveListing');
                var renderedHtml = $(tplElement).render(compositeModel, cision.websolution.formatHelpers);

                if (firstRunArchive) {
                    var renderedCategories = $("#tplCategories").render({ categories: categories });
                    $("#target-categories").html(renderedCategories);
                }

                var tplTarget = '#' + (settings.calendarOutputTargetElement || 'archiveEventListTarget');
                $(tplTarget).html(renderedHtml);

                firstRunArchive = false;

            })
            .fail(function () {
                console.log('Could not retrieve archived calendar data');
            });
    };

    var getEventByGuid = function (options) {

        var eventGuid = options.eventGuid;

        if (options) {
            $.extend(settings, options);
        }
        if (settings.accessKey) {
            accessKey = settings.accessKey;
        }
        if (!eventGuid) {
            console.log("You must provide a event guid.");
            return;
        }

        var url = generateUrl('Calendar/' + accessKey + '/EventDetail');
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            data: {
                    eventguid: eventGuid,
                    LanguageCode: settings.uiLanguage
                }
            })
        .done(function (objEvent) {
            objEvent.EventDateFormatted = moment(objEvent.EventTime).locale(settings.uiLanguage).format(settings.dateFormatEvent);
            objEvent.EventTimeFormattedDate = moment(objEvent.EventTime).locale(settings.uiLanguage).format(settings.dateFormat);
            objEvent.EventTimeFormattedTime = moment(objEvent.EventTime).locale(settings.uiLanguage).format(settings.timeFormat);

            objEvent.PublishTimeFormatted = moment(objEvent.PublishTime).locale(settings.uiLanguage).format(settings.dateFormatNews);
            objEvent.ArchiveTimeFormatted = moment(objEvent.ArchiveTime).locale(settings.uiLanguage).format(settings.dateFormatNews);

            var compositeModel = $.extend({}, objEvent, texts, settings),
                renderedHtml = $("#tplEventDetail").render(compositeModel, cision.websolution.formatHelpers);

            $("#target-event-detail").html(renderedHtml);

        })
            .fail(function () {
                console.log('Could not retrieve release Detailed data');
            });
    };

    return {
        getEventByGuid: getEventByGuid,
        renderEventList: renderEventList,
        renderArchiveList: renderArchiveList,
        renderSidebarCalendar: renderSidebarCalendar
    };
}(jQuery);
